import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import OfferTypeModel from 'models/OfferType';

import Wrapper from './styled/Wrapper';
import ProjectListItem from './styled/ProjectListItem';

export default class OfferSection extends PureComponent {


  state = {
    activeOffer: null,
  };

  onMouseEnter = offer => {
    this.setState({ activeOffer: offer });
  };

  onMouseLeave = () => {
    this.setState({ activeOffer: null });
  };

  render() {
    const { offerTypes } = this.props;
    const { activeOffer } = this.state;

    return (
      <Wrapper>
        {offerTypes.map(offer => (
          <ProjectListItem
            big
            key={offer.id}
            project={{
              ...offer,
              category: { id: 1, name: '' },
              grade: { id: 1, name: '' },
            }}
            isActive={activeOffer === offer}
            isInactive={activeOffer !== null && activeOffer !== offer}
            onMouseEnter={() => this.onMouseEnter(offer)}
            onMouseLeave={this.onMouseLeave}
            offer={true}
            baseLink="/capabilities"
          >
            {offer.description}
          </ProjectListItem>
        ))}
      </Wrapper>
    );
  }
}
